export default __webpack_public_path__ + "static/media/dock.6901cee3.png";